// Microsoft Clarity error handling
  (function () {
    const ignorePatterns = [
      /Script error/i,
      /Cannot read properties of null/i,
      /Cannot read properties of undefined/i,
      /notStartsWith/i,
      /Drift is not defined/i,
      /e\.forEach is not a function/i
    ];
    function shouldIgnore(msg) {
      return ignorePatterns.some(p => p.test(String(msg)));
    }
    window.onerror = function (msg) {
      if (shouldIgnore(msg)) return true;
      return false;
    };
    window.addEventListener("unhandledrejection", function (event) {
      const reason = event.reason?.message || event.reason || "";
      if (shouldIgnore(reason)) event.preventDefault();
    });
    const origConsoleError = console.error;
    console.error = function (...args) {
      const str = args.join(" ");
      if (shouldIgnore(str)) return;
      origConsoleError.apply(console, args);
    };
  })();



document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".main-product-title");

  if (el) {
    el.innerHTML = el.innerHTML.replace(/(\d+\+*)/g, '<span class="number-font">$1</span>');
  }
});

